import React, { useState, useRef, useEffect } from "react";
import Image from "next/legacy/image";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Typography from "@mui/material/Typography";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Rating from "@mui/material/Rating";
import dynamic from "next/dynamic";
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";
import style from "../../styles/pujaReviews.module.css";
import defaultProfilePic from "@public/assets/images/blank-profile-picture.png";
import { useRouter } from "next/router";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import useCollapse from "react-collapsed";
const LinkPreview = dynamic(() => import("@components/post/LinkPreview"));
const ReviewCard = ({
  data
}) => {
  const {
    t
  } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [images, setImages] = useState([]);
  const [reviewClicked, setReviewClicked] = useState({});
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  const [arrows, setArrows] = useState(data?.video === "" && data?.images.length > 2);
  const sliderRef = useRef();
  const bigSliderRef = useRef();
  const router = useRouter();
  const smallScreen = useMediaQuery("(max-width:768px)");
  const res = {
    limited_text: data?.video == "" && data?.review?.length > 140 ? data?.review?.slice(0, 141) : data?.video != "" && data?.review?.length > 120 ? data?.review?.slice(0, 121) : data.review,
    moreTextFlag: data?.video == "" && data?.review?.length > 140 ? true : data?.video != "" && data?.review?.length > 120 ? true : false
  };
  const [showMoreText, setShowMoreText] = useState(false);
  const [moreTextFlag, setMoreTextFlag] = useState(res.moreTextFlag);
  const [review, setReview] = useState(data?.video == "" && data?.review?.length > 140 ? data?.review?.slice(0, 141) : data?.video != "" && data?.review?.length > 120 ? data.review?.slice(0, 121) : data.review);
  const {
    getCollapseProps,
    getToggleProps
  } = useCollapse({
    collapsedHeight: 50
  });
  const [showMore, setShowMore] = useState(false);
  const [showMoreBtn, setShowMoreBtn] = useState(true);
  useEffect(() => {
    if (data.review) {
      setShowMoreBtn(!smallScreen ? data?.review?.length > 100 : data?.review?.length > 65);
    }
  }, [data.review]);
  function showMoreHeadlineTextHandle(element) {
    // if (showMoreText) {
    //   element.currentTarget.innerHTML = `${t("show-more-0")}`;
    //   setReview(res.limited_text);
    // } else {
    //   element.currentTarget.innerHTML = `${t("show-less")}`;
    //   setReview(data.review);
    // }

    setShowMoreText(!showMoreText);
  }
  const convertDate = ts => {
    const d = new Date(ts);
    return d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
  };
  const BigImageCarousel = () => {
    const settings2 = {
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 3,
      initialSlide: 0,
      className: "imagesContainer",
      centerMode: true,
      dotsClass: "slick-dots slick-thumb",
      arrows: false,
      dots: true,
      centerPadding: 0,
      customPaging: function (i) {
        return <a className={style.PageLink}>
            {/* {reviewClicked?.images_sm?.map((image)=>{ */}
            <Image src={reviewClicked?.images_sm[i]} alt={t("eventdp")} width="200" height="200" objectFit="cover"
          //priority
          loading="lazy" />
            {/* })} */}
          </a>;
      }
    };
    return <div data-sentry-component="BigImageCarousel" data-sentry-source-file="ReviewPuja.jsx">
        <Modal open={open} onClose={handleClose} data={images} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" data-sentry-element="Modal" data-sentry-source-file="ReviewPuja.jsx">
          <Box sx={style} className={style.mModal} data-sentry-element="Box" data-sentry-source-file="ReviewPuja.jsx">
            <div className={style.BigReviewCarouselContainer}>
              <Slider ref={bigSliderRef} {...settings2} data-sentry-element="Slider" data-sentry-source-file="ReviewPuja.jsx">
                {images.map((image, index) => {
                return <div key={index.toString()} className={style.BigItem} style={{
                  width: "100%",
                  height: "100%",
                  position: "relative"
                }}>
                      <Image src={image} alt={t("eventdp")} width="600" height="400"
                  // layout='fill'
                  objectFit="contain"
                  // priority
                  loading="lazy" />
                    </div>;
              })}
              </Slider>
            </div>

            <div className={style.modalRHs}>
              <CardHeader className={style.reviewHeader}
            // avatar={
            //   <Avatar
            //     sx={{ width: "50px", height: "50px" }}
            //     aria-label="avatar"
            //   >
            //     <Image
            //       src={reviewClicked?.User?.dp_sm}
            //       alt={t("eventdp")}
            //       width="50"
            //       height="50"
            //       objectFit="cover"
            //       priority
            //     />
            //   </Avatar>
            // }
            title={<p className={style.reviewAuthor}>
                    {" "}
                    {reviewClicked?.User?.name}{" "}
                  </p>} subheader={<div className={style.subHeader}>
                    <span>{data.CommunitySubEvent.name}</span>
                  </div>} data-sentry-element="CardHeader" data-sentry-source-file="ReviewPuja.jsx" />
              <CardContent className={style.cardContent} data-sentry-element="CardContent" data-sentry-source-file="ReviewPuja.jsx">
                <div style={{
                height: "150px"
              }}>
                  <Typography variant="body2" className={style.cardContentText} data-sentry-element="Typography" data-sentry-source-file="ReviewPuja.jsx">
                    {reviewClicked?.review}
                  </Typography>
                </div>
              </CardContent>

              <Rating className={style.reviewRating} name="read-only" value={reviewClicked?.rating} readOnly data-sentry-element="Rating" data-sentry-source-file="ReviewPuja.jsx" />

              <div className={style.reviewDate} style={{
              marginLeft: 0
            }}>
                <span>{convertDate(Number(reviewClicked?.ts))}</span>
              </div>
            </div>
          </Box>
        </Modal>
      </div>;
  };
  return <div className={style.singleReviewCarousel} data-sentry-component="ReviewCard" data-sentry-source-file="ReviewPuja.jsx">
      <CardContent className={`${style.cardContent} ${review && style.cardContentReview}`} data-sentry-element="CardContent" data-sentry-source-file="ReviewPuja.jsx">
        {/* @arnab for longer text the scroll not working properly */}
        {/* {smallScreen ? ( */}
        <Box data-sentry-element="Box" data-sentry-source-file="ReviewPuja.jsx">
          {showMoreBtn ? <div
        // className={`${review && style.reviewWrapper}`}
        {...getCollapseProps()}>
              <Typography variant="body2" className={style.reviewText}>
                {data.review}
              </Typography>
            </div> : <div
        // className={`${review && style.reviewWrapper}`}
        >
              <Typography variant="body2" className={style.reviewText}>
                {data.review}
              </Typography>
            </div>}
          {showMoreBtn && <div className={style.show_more_text}
        // onClick={showMoreHeadlineTextHandle}
        {...getToggleProps({
          onClick: () => {
            // toggleShowMore();
            setShowMore(cur => !cur);
          }
        })}>
              {showMore ? `${t("see-less")}` : `${t("see-more")}`}
            </div>}
        </Box>
      </CardContent>

      <div className={style.ratingCardContainer}>
        <Rating name="read-only" value={data?.rating} readOnly size="large" sx={{
        color: "#27AE60"
      }} data-sentry-element="Rating" data-sentry-source-file="ReviewPuja.jsx" />
        <CardHeader sx={{
        padding: "10px",
        "& .MuiCardHeader-avatar": {
          marginRight: "12px"
        }
      }} avatar={data?.dp && <div style={{
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        overflow: "hidden"
        // marginRight: "8px",
      }} aria-label="avatar">
                <Image src={data?.dp || defaultProfilePic} alt={t("eventdp")} width="60" height="60" objectFit="cover" />
              </div>} title={<p className={style.reviewAuthor}>{data?.name}</p>} subheader={<div className={style.subHeader}>
              <span>{data.location}</span>
            </div>} data-sentry-element="CardHeader" data-sentry-source-file="ReviewPuja.jsx" />
      </div>

      {/* <BigImageCarousel /> */}
    </div>;
};
export default ReviewCard;